import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { CheckCircle2, Home as HomeIcon, ArrowRight } from "lucide-react";
import { useEffect, useRef } from "react";

export default function ThankYou() {
  const hasFiredRef = useRef(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });

    // Google Ads — Lead form submission conversion (label 9t1sCObmt78cEMnqvNVC).
    // Guarded with a useRef so React StrictMode's dev-time double-invocation
    // of effects doesn't fire the event twice per page view. In the production
    // build this guard is a no-op (effects run once anyway).
    if (hasFiredRef.current) return;
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-17895994697/9t1sCObmt78cEMnqvNVC",
      });
      hasFiredRef.current = true;
    }
  }, []);

  return (
    <div data-testid="thank-you-page" className="text-white">
      <Seo />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-radial-fade" />
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="relative mx-auto max-w-3xl px-4 md:px-8 lg:px-12 py-24 md:py-32 text-center">
          <div className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-[#FE7200]/15 border border-[#FE7200]/30 ring-4 ring-[#FE7200]/10">
            <CheckCircle2 className="h-10 w-10 text-[#FE7200]" />
          </div>
          <h1 className="mt-8 font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05]">
            Thank you — we'll be in touch shortly.
          </h1>
          <p className="mt-5 text-base sm:text-lg text-zinc-300 max-w-xl mx-auto">
            Your request has been received. A member of the Anytime Vending Machines team will review your details, confirm eligibility, and reach out to arrange your free site visit — usually within one business day.
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              data-testid="thank-you-home-button"
              className="inline-flex items-center gap-2 rounded-full bg-[#FE7200] px-6 py-3 text-sm font-bold uppercase tracking-wider text-black hover:bg-[#FF8C2E] transition-colors"
            >
              <HomeIcon className="h-4 w-4" /> Back To Home
            </Link>
            <Link
              to="/blog"
              data-testid="thank-you-blog-button"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-6 py-3 text-sm font-bold uppercase tracking-wider text-white hover:bg-white/10 transition-colors"
            >
              Read Vending Tips <ArrowRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
            {[
              { label: "Next step", value: "Eligibility review" },
              { label: "Response time", value: "Within 1 business day" },
              { label: "Then", value: "Free on-site visit" },
            ].map((s) => (
              <div key={s.label} className="rounded-2xl border border-white/10 bg-[#121212] p-5">
                <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#FE7200]">{s.label}</div>
                <div className="mt-1 text-white font-display text-lg font-bold">{s.value}</div>
              </div>
            ))}
          </div>

          <p className="mt-10 text-xs text-zinc-500">
            Need to reach us sooner? Email <a className="text-[#FE7200] hover:underline" href="mailto:info.nector@gmail.com">info.nector@gmail.com</a>
          </p>
        </div>
      </section>
    </div>
  );
}
